module.exports = __webpack_public_path__ + "static/media/TRIAL-1-unanswered-10-sec.01744a98.mp3";